import { PLAYOUT_DATA_TYPE, WEB_DATA_TYPE } from "../../state/modules/app/playout/constant";


export const NON_SELECTED_ADVERTISER = 'none';

export const ALL_TYPE = 'all';

export const SUCCESS = 'success';
export const FAILED = 'failed';
export const ALL_STATUS = 'all';

export const STATUS_ENGINE = {
    PRE_PROCESS: 0,
    PROCESSING: 1,
    PROCESSED: 2,
    ERROR: -1, // job failed
    COMPLETE_WITH_ERROR: 3 // job completed but invalid data
}

export const STATUS_OPTIONS_HASHMAP = {
    [SUCCESS]: [STATUS_ENGINE.PROCESSED],
    [FAILED]: [STATUS_ENGINE.ERROR, STATUS_ENGINE.COMPLETE_WITH_ERROR],
    [ALL_STATUS]: [...Object.values(STATUS_ENGINE), null]//null value if the file/job status is default
};

export const SELECTED_ADVERTISER_ID = 'advertiserId';
export const SELECTED_STATUS = 'uploadStatus';
export const SELECTED_TYPE = 'uploadType';

export const DAILY = 'daily';
export const WEEKLY = 'weekly';
export const MONTHLY = 'monthly';
export const timeOptions = [{
  value: DAILY,
  label: 'Daily'
}, {
  value: WEEKLY,
  label: 'Weekly'
}, {
  value: MONTHLY,
  label: 'Monthly'
}];

export const typeOptions = [
  {
    value: PLAYOUT_DATA_TYPE,
    label: 'Playout'
  },
  {
    value: WEB_DATA_TYPE,
    label: 'Web'
  },
  {
    value: 'all',
    label: 'All'
  },
];

export const statusOptions = [
  {
    value: 'success',
    label: 'Success'
  },
  {
    value: 'failed',
    label: 'Failed'
  },
  {
    value: 'all',
    label: 'All'
  }
];

export const dateFormat = 'MM/DD/YYYY';
export const monthlyChartKey = 'MMM-YYYY';
export const monthlyFormat = 'MMM YYYY';

export const WEEKLY_LABEL_DISTANCE = 150;
export const DEFAULT_LABEL_DISTANCE = 80;
